@if (item(); as item) {
  <div class="flex flex-col gap-1">
    <button
      (click)="toggle($event)"
      class="p-2 rounded-md transition-colors flex w-full justify-between items-center hover:bg-gray-100"
    >
      <div class="flex gap-2 items-center">
        <app-checkbox
          (click)="handleClick($event)"
          (valueChange)="handleAllCheck($event)"
        />
        <p>{{ item.group }}</p>
      </div>
      <app-icon [class.rotate-180]="open()" name="mdi:chevron-down" />
    </button>
    @if (open()) {
      <div class="flex flex-col gap-1 pl-6">
        @for (option of item.options; track $index) {
          <app-select-group-option
            [values]="values()"
            [bindLabel]="bindLabel()"
            [bindValue]="bindValue()"
            (checked)="handleCheck($event, option)"
            [option]="option"
          />
        }
      </div>
    }
  </div>
}
